import { computed, watch, nextTick, openBlock, createBlock, Transition, withCtx, createElementBlock, normalizeClass, createElementVNode, renderSlot, withModifiers, createCommentVNode, defineComponent, Fragment, renderList, resolveDynamicComponent, createTextVNode, toDisplayString, ref, normalizeProps, guardReactiveProps, Teleport, createVNode, mergeProps, reactive, resolveComponent, withDirectives, vModelText, h, onBeforeUnmount, resolveDirective, unref, getCurrentScope, onScopeDispose, normalizeStyle, onUnmounted, useSlots, provide, getCurrentInstance, watchEffect, inject } from "vue";
import { uniqBy, groupBy } from "lodash";
import { useMagicKeys, useVModel, syncRef, whenever, useClipboard, useElementSize, usePointerSwipe, useElementVisibility } from "@vueuse/core";
import { useSharer, useNetworks, useNotifier, useToaster, useResponsive, toHTML, usePopup } from "@bignerve/ui-shared";
import { numeric } from "@bignerve/ui-utils";
import VStarRating from "vue-star-rating";
import { RouterLink } from "vue-router";
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const types$1 = {
  warning: "orange",
  success: "green",
  danger: "red",
  info: "blue"
};
const _sfc_main$n = {
  name: "Alert",
  props: {
    active: Boolean,
    duration: {
      type: Number,
      default: 1e3 * 10
    },
    closable: Boolean,
    dense: Boolean,
    color: {
      type: String
    },
    type: {
      type: String,
      default: "warning"
    }
  },
  emits: ["update:active"],
  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.active,
      set: (value) => emit("update:active", value)
    });
    const cl = computed(() => props.color || types$1[props.type]);
    watch(isOpen, (activated) => {
      if (activated && !props.closable) {
        setTimeout(async () => {
          await nextTick();
          isOpen.value = false;
        }, props.duration);
      }
    }, { immediate: true });
    return {
      isOpen,
      cl
    };
  }
};
const _hoisted_1$f = /* @__PURE__ */ createElementVNode("span", null, "×", -1);
const _hoisted_2$d = [
  _hoisted_1$f
];
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "n-alert",
    "enter-active-class": "transition ease-out duration-300",
    "leave-active-class": "transition ease-in duration-300",
    "enter-from-class": "transform opacity-0",
    "enter-to-class": "transform opacity-1",
    "leave-from-class": "transform opacity-1",
    "leave-to-class": "transform opacity-0",
    mode: "out-in",
    appear: ""
  }, {
    default: withCtx(() => [
      $setup.isOpen ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["flex items-center overflow-hidden rounded-md", `bg-${$setup.cl}-100 text-${$setup.cl}-600`]),
        role: "alert"
      }, [
        createElementVNode("div", {
          class: normalizeClass(["w-2", `bg-${$setup.cl}-600`])
        }, null, 2),
        createElementVNode("div", {
          class: normalizeClass(["flex-1 ml-1", $props.dense ? "p-1" : "p-2"])
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2),
        $props.closable ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: normalizeClass([`hover:bg-${$setup.cl}-200`, "flex items-center justify-center h-6 w-6 mr-2 rounded-full text-2xl font-semibold leading-none outline-none focus:outline-none"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $setup.isOpen = false, ["prevent"]))
        }, _hoisted_2$d, 2)) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
const Alert = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$a]]);
const _hoisted_1$e = {
  class: "mb-4 flex items-center",
  "aria-label": "Breadcrumb"
};
const _hoisted_2$c = {
  class: "flex items-center",
  style: { "padding-left": "0" }
};
const _hoisted_3$a = {
  key: 0,
  class: "fill-current w-3 h-3 mx-2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
};
const _hoisted_4$7 = /* @__PURE__ */ createElementVNode("path", { d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" }, null, -1);
const _hoisted_5$5 = [
  _hoisted_4$7
];
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "Breadcrumbs",
  props: {
    breadcrumbs: { default: () => [] },
    context: { default: () => ({}) },
    prepend: { default: () => [] },
    append: { default: () => [] }
  },
  setup(__props) {
    const props = __props;
    const computedBreadcrumbs = computed(() => {
      return [
        ...props.prepend,
        ...uniqBy(props.breadcrumbs, "title"),
        ...props.append
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1$e, [
        renderSlot(_ctx.$slots, "prepend", { breadcrumbs: computedBreadcrumbs.value }),
        createElementVNode("ol", _hoisted_2$c, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(computedBreadcrumbs.value, (breadcrumb, i) => {
            return openBlock(), createElementBlock("li", {
              key: i,
              class: "flex items-center"
            }, [
              (openBlock(), createBlock(resolveDynamicComponent(i + 1 < computedBreadcrumbs.value.length ? "router-link" : "span"), {
                to: breadcrumb.route,
                class: normalizeClass([i + 1 === computedBreadcrumbs.value.length ? "text-dust" : "text-dust-900", "font-semibold"])
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(breadcrumb.title), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])),
              i + 1 < computedBreadcrumbs.value.length ? (openBlock(), createElementBlock("svg", _hoisted_3$a, _hoisted_5$5)) : createCommentVNode("", true)
            ]);
          }), 128))
        ]),
        renderSlot(_ctx.$slots, "append", { breadcrumbs: computedBreadcrumbs.value })
      ]);
    };
  }
});
const _hoisted_1$d = { class: "relative bg-gray-200 aspect-6/9" };
const _hoisted_2$b = ["src"];
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "Image",
  props: {
    src: String,
    fallback: {
      type: String,
      default: "https://bignerve.com/img/challenge-image-defaults/challenge-preview-placeholder.svg"
    }
  },
  setup(__props) {
    const props = __props;
    const resolveFallback = (e) => {
      e.target.src = props.fallback;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$d, [
        createElementVNode("img", {
          class: "absolute inset-0 w-full h-full object-cover",
          src: __props.src,
          loading: "lazy",
          alt: "",
          onErrorOnce: resolveFallback
        }, null, 40, _hoisted_2$b)
      ]);
    };
  }
});
const _sfc_main$k = {
  name: "Modal",
  props: {
    open: Boolean,
    closeOnBackdrop: {
      type: Boolean,
      default: true
    }
  },
  inheritAttrs: false,
  emits: ["close", "show", "update:open"],
  setup(props, { emit }) {
    const keys2 = useMagicKeys();
    const state = useVModel(props, "open", emit);
    const showModal = ref(false);
    const showBackdrop = ref(false);
    const showContent = ref(false);
    const backdropLeaving = ref(false);
    const contentLeaving = ref(false);
    const leaving = computed(
      () => backdropLeaving.value || contentLeaving.value
    );
    const show = () => {
      showModal.value = true;
      showBackdrop.value = true;
      showContent.value = true;
      emit("show");
    };
    const close = () => {
      showBackdrop.value = false;
      showContent.value = false;
      showModal.value = false;
      emit("close");
    };
    syncRef(showModal, state, { direction: "ltr" });
    watch(() => props.open, () => {
      props.open ? show() : close();
    }, { immediate: true });
    watch(leaving, (active) => {
      if (!active) {
        showModal.value = false;
        emit("close");
      }
    });
    whenever(keys2.Escape, () => {
      if (showModal.value)
        close();
    });
    return {
      show,
      close,
      showModal,
      showContent,
      contentLeaving,
      showBackdrop,
      backdropLeaving,
      leaving
    };
  }
};
const _hoisted_1$c = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-20"
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    renderSlot(_ctx.$slots, "activator", normalizeProps(guardReactiveProps({ on: { click: $setup.show }, close: $setup.close, show: $setup.show }))),
    (openBlock(), createBlock(Teleport, { to: "body" }, [
      $setup.showModal ? (openBlock(), createElementBlock("div", _hoisted_1$c, [
        createVNode(Transition, {
          onBeforeLeave: _cache[1] || (_cache[1] = ($event) => $setup.backdropLeaving = true),
          onAfterLeave: _cache[2] || (_cache[2] = ($event) => $setup.backdropLeaving = false),
          "enter-active-class": "transition-all transition-fast ease-out-quad",
          "leave-active-class": "transition-all transition-medium ease-in-quad",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0",
          appear: ""
        }, {
          default: withCtx(() => [
            $setup.showBackdrop ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "absolute inset-0 bg-black bg-opacity-40",
              onClick: _cache[0] || (_cache[0] = ($event) => $props.closeOnBackdrop && $setup.close())
            })) : createCommentVNode("", true)
          ]),
          _: 1
        }),
        createVNode(Transition, {
          onBeforeLeave: _cache[3] || (_cache[3] = ($event) => $setup.contentLeaving = true),
          onAfterLeave: _cache[4] || (_cache[4] = ($event) => $setup.contentLeaving = false),
          "enter-active-class": "transition-all transition-fast ease-out-quad",
          "leave-active-class": "transition-all transition-medium ease-in-quad",
          "enter-from-class": "opacity-0 scale-70",
          "enter-to-class": "opacity-100 scale-100",
          "leave-from-class": "opacity-100 scale-100",
          "leave-to-class": "opacity-0 scale-70",
          appear: ""
        }, {
          default: withCtx(() => [
            $setup.showContent ? (openBlock(), createElementBlock("div", mergeProps({
              key: 0,
              class: "relative"
            }, _ctx.$attrs), [
              renderSlot(_ctx.$slots, "default", { close: $setup.close })
            ], 16)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ])) : createCommentVNode("", true)
    ]))
  ], 64);
}
const Modal = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$9]]);
const _hoisted_1$b = { class: "max-w-lg w-full bg-white rounded-lg shadow-2xl px-8 py-6" };
const _hoisted_2$a = { class: "flex items-center justify-between mb-4" };
const _hoisted_3$9 = {
  key: 0,
  class: "font-semibold text-gray-800 text-lg leading-tight m-0"
};
const _hoisted_4$6 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1);
const _hoisted_5$4 = [
  _hoisted_4$6
];
const _hoisted_6$4 = { class: "mt-2 text-gray-700" };
const _hoisted_7$2 = { class: "mt-6 flex justify-end space-x-2" };
const _hoisted_8$2 = ["disabled"];
const _hoisted_9$2 = {
  key: 0,
  class: "animate-spin mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_10$2 = /* @__PURE__ */ createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1);
const _hoisted_11$2 = /* @__PURE__ */ createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1);
const _hoisted_12$2 = [
  _hoisted_10$2,
  _hoisted_11$2
];
const __default__$8 = {
  name: "Notify"
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  ...__default__$8,
  props: {
    show: { type: Boolean },
    title: {},
    message: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    closable: { type: Boolean, default: false },
    danger: { type: Boolean, default: false },
    asyncConfirm: { type: Function, default: null },
    confirmText: { default: "OK" },
    cancelText: { default: "Cancel" }
  },
  emits: ["close", "confirm", "cancel", "update:show"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const processing = ref(false);
    const payload = ref({});
    const opened = ref(false);
    const open = (v = {}) => {
      if (typeof v === "function") {
        payload.value = v(payload.value);
      } else if (typeof v === "object") {
        payload.value = v;
      } else {
        payload.value = { message: v };
      }
      opened.value = true;
    };
    const close = () => {
      opened.value = false;
      emit("close");
    };
    const cancel = () => {
      emit("cancel", payload.value);
      close();
    };
    const confirm = async () => {
      try {
        processing.value = true;
        if (props.asyncConfirm) {
          await props.asyncConfirm(payload.value);
        }
        emit("confirm", payload.value);
        close();
      } finally {
        processing.value = false;
      }
    };
    watch(() => props.show, (value) => {
      opened.value = value;
    }, {
      immediate: true
    });
    watch(() => opened.value, (value) => {
      emit("update:show", value);
    });
    __expose({
      open,
      close,
      cancel,
      confirm
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        renderSlot(_ctx.$slots, "activator", normalizeProps(guardReactiveProps({ on: { click: open }, close, open }))),
        createVNode(Modal, {
          open: opened.value,
          class: "m-5 sm:m-0",
          onClose: close
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_1$b, [
              createElementVNode("div", _hoisted_2$a, [
                renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps(payload.value)), () => [
                  _ctx.title ? (openBlock(), createElementBlock("h2", _hoisted_3$9, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true)
                ]),
                _ctx.closable ? (openBlock(), createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "w-8 h-8 text-gray-500 flex items-center justify-center rounded-full focus:outline-none hover:(bg-gray-100 text-gray-600) -mr-2",
                  onClick: close
                }, _hoisted_5$4)) : createCommentVNode("", true)
              ]),
              renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(payload.value)), () => [
                createElementVNode("p", _hoisted_6$4, toDisplayString(_ctx.message), 1)
              ]),
              createElementVNode("div", _hoisted_7$2, [
                renderSlot(_ctx.$slots, "actions", normalizeProps(guardReactiveProps({ cancel, confirm, cancelText: _ctx.cancelText, confirmText: _ctx.confirmText, close, message: _ctx.message, payload: payload.value, disabled: _ctx.disabled })), () => [
                  createElementVNode("button", {
                    class: "ml-4 px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline",
                    onClick: cancel
                  }, toDisplayString(_ctx.cancelText), 1),
                  createElementVNode("button", {
                    disabled: _ctx.disabled || _ctx.loading || processing.value,
                    type: "button",
                    class: normalizeClass([[_ctx.disabled || _ctx.loading || processing.value ? "cursor-not-allowed opacity-90" : "focus:shadow-outline", _ctx.danger ? "bg-red-500 hover:bg-red-600" : "bg-blue-500 hover:bg-blue-600"], "px-4 py-2 text-white font-semibold border border-transparent rounded focus:outline-none flex items-center"]),
                    onClick: confirm
                  }, [
                    _ctx.loading || processing.value ? (openBlock(), createElementBlock("svg", _hoisted_9$2, _hoisted_12$2)) : createCommentVNode("", true),
                    createTextVNode(" " + toDisplayString(_ctx.confirmText), 1)
                  ], 10, _hoisted_8$2)
                ])
              ])
            ])
          ]),
          _: 3
        }, 8, ["open"])
      ], 64);
    };
  }
});
const _sfc_main$i = {
  name: "Sharer",
  setup() {
    const { opened } = useSharer();
    const { setNetwork } = useNetworks();
    const { copy: clipboard } = useClipboard();
    const field = ref(null);
    const copied = ref(false);
    const sharing = reactive({
      url: window.location.href,
      title: "Share",
      description: "New sharing",
      hashtags: "",
      quote: "",
      twitterUser: ""
    });
    setNetwork("imgur", "https://imgur.com");
    const networks = [
      { network: "twitter", name: "Twitter", icon: "twitter", enabled: true },
      { network: "facebook", name: "Facebook", icon: "facebook-f-brands", enabled: true },
      { network: "email", name: "Email", icon: "envelope-regular", enabled: true },
      { network: "imgur", name: "Imgur", icon: "imgur", enabled: false },
      { network: "reddit", name: "Reddit", icon: "reddit-alien-brands", enabled: true }
    ];
    const copy = async () => {
      await clipboard(sharing.value);
      field.value.select();
      copied.value = true;
      setTimeout(() => {
        copied.value = false;
      }, 5e3);
    };
    return {
      networks,
      opened,
      copied,
      sharing,
      field,
      copy
    };
  }
};
const _hoisted_1$a = { class: "rounded-lg overflow-hidden max-w-sm" };
const _hoisted_2$9 = { class: "bg-nerve px-3 py-2 text-white flex items-center justify-between" };
const _hoisted_3$8 = { class: "font-narrow text-base font-bold" };
const _hoisted_4$5 = { class: "bg-white px-3 py-4 font-narrow" };
const _hoisted_5$3 = /* @__PURE__ */ createElementVNode("p", { class: "font-bold mb-2" }, "Here is your personalized sharing “scout” URL:", -1);
const _hoisted_6$3 = { class: "flex items-center space-x-2 mb-2" };
const _hoisted_7$1 = /* @__PURE__ */ createElementVNode("p", { class: "text-sm mb-2" }, [
  /* @__PURE__ */ createElementVNode("span", { class: "font-bold" }, "Post directly to your social channels"),
  /* @__PURE__ */ createTextVNode(),
  /* @__PURE__ */ createElementVNode("span", { class: "text-dust" }, "(tap an icon)"),
  /* @__PURE__ */ createTextVNode(": ")
], -1);
const _hoisted_8$1 = { class: "grid grid-cols-3" };
const _hoisted_9$1 = {
  type: "button",
  class: "rounded-sm font-bold px-2 py-1 text-dust",
  disabled: ""
};
const _hoisted_10$1 = /* @__PURE__ */ createElementVNode("div", { class: "border-b-2 border-dust border-dashed my-3" }, null, -1);
const _hoisted_11$1 = /* @__PURE__ */ createElementVNode("div", { class: "flex items-center justify-between" }, [
  /* @__PURE__ */ createElementVNode("button", {
    type: "button",
    class: "bg-dust px-2 py-1 rounded-md text-white font-narrow text-base font-bold",
    disabled: ""
  }, " Share Later "),
  /* @__PURE__ */ createElementVNode("button", {
    type: "button",
    class: "bg-dust px-2 py-1 rounded-md text-white font-narrow text-base font-bold",
    disabled: ""
  }, " Share Panel ")
], -1);
const _hoisted_12$1 = /* @__PURE__ */ createElementVNode("div", { class: "flex justify-between text-sm text-dust-800 px-2 mt-1" }, [
  /* @__PURE__ */ createElementVNode("span", null, "Save to queue"),
  /* @__PURE__ */ createElementVNode("span", null, "Personalize first...")
], -1);
const _hoisted_13 = /* @__PURE__ */ createElementVNode("p", { class: "text-sm px-2" }, [
  /* @__PURE__ */ createElementVNode("b", null, "Automate!"),
  /* @__PURE__ */ createTextVNode(" Set up your social integrations & automation in the "),
  /* @__PURE__ */ createElementVNode("a", {
    href: "#",
    class: "underline"
  }, "Advanced Sharing Panel"),
  /* @__PURE__ */ createTextVNode(". ")
], -1);
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_n_icon = resolveComponent("n-icon");
  const _component_n_share_network = resolveComponent("n-share-network");
  const _component_n_modal = resolveComponent("n-modal");
  return openBlock(), createBlock(_component_n_modal, {
    open: $setup.opened,
    onClose: _cache[3] || (_cache[3] = ($event) => $setup.opened = false)
  }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$a, [
        createElementVNode("div", _hoisted_2$9, [
          createElementVNode("span", _hoisted_3$8, [
            createVNode(_component_n_icon, {
              as: "share-square-solid",
              left: ""
            }),
            createTextVNode("Share ")
          ]),
          createElementVNode("button", {
            type: "button",
            class: "w-6 h-6 flex items-center justify-center hover:bg-nerve-600 rounded-full outline-none",
            onClick: _cache[0] || (_cache[0] = ($event) => $setup.opened = false)
          }, [
            createVNode(_component_n_icon, { as: "times-circle-regular" })
          ])
        ]),
        createElementVNode("div", _hoisted_4$5, [
          _hoisted_5$3,
          createElementVNode("div", _hoisted_6$3, [
            withDirectives(createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.sharing.url = $event),
              ref: "field",
              type: "text",
              class: "flex-1 border rounded-sm px-2 py-1 outline-none",
              readonly: ""
            }, null, 512), [
              [vModelText, $setup.sharing.url]
            ]),
            createElementVNode("button", {
              type: "button",
              class: "text-white bg-nerve hover:bg-nerve-600 font-bold px-3 py-1 rounded-sm outline-none",
              onClick: _cache[2] || (_cache[2] = (...args) => $setup.copy && $setup.copy(...args))
            }, toDisplayString($setup.copied ? "Copied!" : "Copy"), 1)
          ]),
          _hoisted_7$1,
          createElementVNode("div", _hoisted_8$1, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($setup.networks, (network) => {
              return openBlock(), createBlock(_component_n_share_network, {
                network: network.network,
                key: network.network,
                url: $setup.sharing.url,
                title: $setup.sharing.title,
                description: $setup.sharing.description,
                quote: $setup.sharing.quote,
                hashtags: $setup.sharing.hashtags,
                twitterUser: $setup.sharing.twitterUser,
                disabled: !network.enabled,
                class: normalizeClass([network.enabled ? "text-blue-600 hover:text-blue-700 hover:bg-gray-100" : "text-dust", "rounded-sm font-bold px-2 py-1"]),
                type: "button",
                tag: "button"
              }, {
                default: withCtx(() => [
                  createVNode(_component_n_icon, {
                    as: network.icon,
                    left: ""
                  }, null, 8, ["as"]),
                  createTextVNode(toDisplayString(network.name), 1)
                ]),
                _: 2
              }, 1032, ["network", "url", "title", "description", "quote", "hashtags", "twitterUser", "disabled", "class"]);
            }), 128)),
            createElementVNode("button", _hoisted_9$1, [
              createVNode(_component_n_icon, {
                as: "binoculars-solid",
                left: ""
              }),
              createTextVNode("Your Recruits ")
            ])
          ]),
          _hoisted_10$1,
          _hoisted_11$1,
          _hoisted_12$1,
          _hoisted_13
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]);
}
const Sharer = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$8]]);
const types = {
  warning: "orange-500",
  success: "green-500",
  danger: "red-500",
  info: "blue-500"
};
const _sfc_main$h = {
  name: "Toast",
  props: {
    active: Boolean,
    duration: {
      type: Number,
      default: 1e3 * 10
    },
    closable: Boolean,
    dense: Boolean,
    color: {
      type: String
    },
    type: {
      type: String,
      default: "warning"
    }
  },
  emits: ["update:active"],
  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.active,
      set: (value) => emit("update:active", value)
    });
    const cl = computed(() => props.color || types[props.type]);
    watch(isOpen, (activated) => {
      if (activated && !props.closable) {
        setTimeout(async () => {
          await nextTick();
          isOpen.value = false;
        }, props.duration);
      }
    }, { immediate: true });
    return {
      isOpen,
      cl
    };
  }
};
const _hoisted_1$9 = {
  key: 0,
  class: "fixed bottom-0 left-0 w-full h-0 flex items-end justify-center z-50"
};
const _hoisted_2$8 = { class: "flex mt-2 sm:mt-0 sm:ml-4" };
const _hoisted_3$7 = /* @__PURE__ */ createElementVNode("span", null, "×", -1);
const _hoisted_4$4 = [
  _hoisted_3$7
];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "toast-notification",
    "enter-active-class": "transition-all transition-fast ease-out-quad",
    "leave-active-class": "transition-all transition-medium ease-in-quad",
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0",
    appear: ""
  }, {
    default: withCtx(() => [
      $setup.isOpen ? (openBlock(), createElementBlock("div", _hoisted_1$9, [
        createElementVNode("div", {
          class: normalizeClass([`bg-${$setup.cl} border-${$setup.cl} text-white`, "w-full px-4 py-3 shadow-2xl flex flex-col items-center border-t sm:w-auto sm:m-4 sm:rounded-lg sm:flex-row sm:border"])
        }, [
          createElementVNode("div", null, [
            renderSlot(_ctx.$slots, "default")
          ]),
          createElementVNode("div", _hoisted_2$8, [
            renderSlot(_ctx.$slots, "actions", {}, () => [
              $props.closable ? (openBlock(), createElementBlock("button", {
                key: 0,
                class: normalizeClass([`hover:bg-${$setup.cl}-200`, "flex items-center justify-center h-6 w-6 mr-2 rounded-full text-2xl font-semibold leading-none outline-none focus:outline-none"]),
                type: "button",
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $setup.isOpen = false, ["prevent"]))
              }, _hoisted_4$4, 2)) : createCommentVNode("", true)
            ])
          ])
        ], 2)
      ])) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
const NToast = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$7]]);
const _sfc_main$g = {
  props: {
    src: String,
    fallback: {
      type: String,
      default: "https://bignerve.com/img/user-profile-images/user-avatar-circle-anon.svg"
    }
  },
  setup(props) {
    const avatar = computed(
      () => props.src && props.src.includes("http") ? props.src : props.fallback
    );
    return {
      avatar
    };
  }
};
const _hoisted_1$8 = { class: "flex-none flex items-center justify-center relative bg-gray-200 h-10 w-10 rounded-full overflow-hidden" };
const _hoisted_2$7 = ["src"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    createElementVNode("img", {
      class: "inset-y-0 absolute h-full w-full object-cover",
      src: $setup.avatar,
      loading: "lazy",
      alt: "",
      onErrorOnce: _cache[0] || (_cache[0] = ($event) => $event.target.src = $props.fallback)
    }, null, 40, _hoisted_2$7)
  ]);
}
const Avatar = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$6]]);
function Icon(props, { attrs, listeners }) {
  const classes = [`icon-${props.as}`, "icon", attrs.class];
  if (props.hasOwnProperty("left")) {
    classes.push("mr-1");
  }
  if (props.hasOwnProperty("right")) {
    classes.push("ml-1");
  }
  return h("span", {
    ...listeners,
    ...attrs,
    class: classes,
    role: "icon"
  });
}
const _sfc_main$f = {
  name: "NNerveLoading",
  props: {
    large: Boolean,
    pulse: Boolean
  }
};
const _hoisted_1$7 = { class: "absolute inset-0 flex items-center justify-center" };
const _hoisted_2$6 = {
  "fill-rule": "nonzero",
  fill: "none"
};
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M16.78 15.987a5.209 5.209 0 004.252-5.115.812.812 0 00-1.624 0 3.579 3.579 0 01-3.57 3.579 3.531 3.531 0 01-1.391-.281.814.814 0 10-.631 1.5c.422.177.865.297 1.318.357a6.273 6.273 0 01-4.534 7.198.814.814 0 00.418 1.571 7.906 7.906 0 005.762-8.809M18.52 45.116a4.985 4.985 0 011.658-6.559.814.814 0 10-.878-1.371 6.624 6.624 0 00-2.876 6.863 6.394 6.394 0 00-3.869.057.813.813 0 10.513 1.544c2.529-.84 5.26.53 6.1 3.058a.81.81 0 101.539-.513 6.431 6.431 0 00-2.187-3.079M20.49 27.735a.814.814 0 00-.216-1.13 2.924 2.924 0 01-1.014-1.509 7.915 7.915 0 011.92-1.217l.188-1.822a9.458 9.458 0 00-6.36 7.58.812.812 0 101.606.234 7.689 7.689 0 011.435-3.473c.3.62.752 1.154 1.314 1.553a.807.807 0 001.127-.216M31.253 15.987a7.906 7.906 0 005.757 8.81.814.814 0 00.419-1.571 6.272 6.272 0 01-4.529-7.201c.452-.06.894-.18 1.315-.358a.814.814 0 10-.631-1.5 3.527 3.527 0 01-1.384.284 3.579 3.579 0 01-3.576-3.579.812.812 0 10-1.624 0 5.209 5.209 0 004.253 5.115M35.194 43.976a6.385 6.385 0 00-3.864-.058 6.578 6.578 0 00-2.659-6.714.813.813 0 00-.934 1.332 4.954 4.954 0 011.49 6.451 6.421 6.421 0 00-2.185 3.077.813.813 0 00.771 1.071.815.815 0 00.769-.558 4.825 4.825 0 016.1-3.058.813.813 0 00.513-1.544",
  fill: "#595959"
}, null, -1);
const _hoisted_4$3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M27.874 53.869c-.158 0-.309-.011-.437-.022l-.093-.009a4.837 4.837 0 01-.414-.064l-.04-.008-.03-.007a4.927 4.927 0 01-.809-.255l-.094-.04a5.95 5.95 0 01-.336-.162l-.017-.01-.022-.013a4.781 4.781 0 01-.332-.2l-.04-.022-.057-.039c-.1-.07-.2-.147-.305-.229l-.035-.03a2.446 2.446 0 01-.355-.327 6.24 6.24 0 01-.247-.273l-.039-.048-.043-.054a4.475 4.475 0 01-.188-.254l-.01-.013a1.408 1.408 0 01-.042-.057l-.033.047-.015.021a4.915 4.915 0 01-.193.257l-.016.02a5.116 5.116 0 01-.313.353c-.025.026-.05.049-.077.074a5.36 5.36 0 01-.239.22l-.035.03-.037.031a4.49 4.49 0 01-.308.23l-.041.027-.05.034c-.1.065-.218.141-.337.206a.077.077 0 00-.032.013 5.608 5.608 0 01-.432.203c-.129.054-.256.1-.378.139-.025.008-.05.016-.074.022-.131.04-.249.07-.363.095H20.9c-.017 0-.035.009-.052.011a4.668 4.668 0 01-.413.064l-.094.009a5.25 5.25 0 01-.437.022 4.817 4.817 0 01-4.621-3.523 5.866 5.866 0 01-6.22-2.181 5.912 5.912 0 01-1.153-2.932 2.98 2.98 0 01-.013-.231v-.09a.82.82 0 01-.053-.284c.002-.484.064-.966.183-1.435A8.186 8.186 0 013 35.665v-.022-.022c0-.134.006-.276.014-.436 0-.026 0-.051.006-.076s0-.056.007-.083c.011-.133.021-.235.032-.329 0-.032.009-.064.013-.1l.008-.063c.016-.117.035-.238.058-.359l.018-.11c.038-.182.072-.33.108-.466 0-.009 0-.018.007-.027a11.78 11.78 0 01.125-.424l.015-.045.031-.09a7.12 7.12 0 01.116-.314l.013-.033.041-.106a4.488 4.488 0 01.176-.4l.013-.03c.068-.138.134-.266.2-.391l.035-.06.059-.1c.05-.085.095-.159.138-.229l.072-.114.041-.064c.041-.063.087-.13.146-.212l.054-.076.062-.087a8.68 8.68 0 01.258-.331l.071-.082.048-.055.045-.051c.048-.055.1-.11.147-.163a2.62 2.62 0 01.122-.128c.1-.1.173-.174.247-.243l.015-.015a8.258 8.258 0 011.266-.981 7.132 7.132 0 01-1.908-4.873 7.175 7.175 0 014.717-6.743 5.85 5.85 0 01-.51-3.081 5.922 5.922 0 016.119-5.309 4.819 4.819 0 014.661-3.685c.127 0 .261.006.437.021h.009l.085.009c.143.016.278.036.413.063l.068.016c.119.025.241.057.363.094l.073.021a4.762 4.762 0 01.468.18c.123.052.235.106.343.165l.021.011.014.004c.121.067.237.142.338.207l.05.034.041.027c.116.081.217.156.308.23l.036.031.036.031c.078.067.158.14.236.216l.08.077c.091.094.173.184.25.276.022.025.042.051.063.077l.016.02c.069.087.134.174.193.257l.029.04.019.026.029-.04.023-.031c.054-.076.118-.165.188-.252l.081-.1c.076-.091.157-.18.247-.274l.081-.078c.075-.074.151-.144.233-.214.016-.012.03-.025.044-.037l.031-.027c.1-.081.2-.158.305-.229l.04-.027.055-.037c.13-.084.232-.147.332-.2l.028-.016.008-.005a5.39 5.39 0 01.336-.162l.094-.04c.113-.049.235-.094.374-.14l.076-.024c.113-.033.234-.064.358-.092l.049-.008.023-.006a5 5 0 01.414-.063l.083-.009h.01a4.8 4.8 0 015.097 3.665h.245a5.919 5.919 0 015.361 8.4 7.1 7.1 0 01.514.208 7.2 7.2 0 014.183 5.967 7.258 7.258 0 01-.014 1.283 7.106 7.106 0 01-1.874 4.156c.43.27.835.58 1.209.924l.036.035.037.036c.088.083.171.165.248.244.033.033.063.067.094.1l.025.028c.065.068.125.136.189.208l.06.075.06.069c.1.127.185.231.257.329.024.032.047.065.07.1l.047.067.032.046c.038.054.076.109.112.166.036.057.07.105.114.177s.092.15.138.229l.094.163c.078.142.145.27.2.392l.014.032.019.043c.048.1.1.211.158.355l.011.028c.013.035.026.07.041.1.037.1.075.2.119.325l.042.125c.046.141.087.277.12.407 0 .011.008.022.011.033v.013c.039.152.072.3.107.473v.021c0 .024.008.046.013.07.024.129.045.257.061.381.006.047.013.1.017.142.012.1.026.222.035.354 0 .035.007.07.009.106v.033a8.58 8.58 0 01-.009 1.101 8.215 8.215 0 01-5 6.9c.119.47.18.951.182 1.435a.827.827 0 01-.051.282c0 .04 0 .079-.005.119 0 .067-.005.137-.012.2A5.943 5.943 0 0134 50.541a5.838 5.838 0 01-1.5-.2 4.8 4.8 0 01-4.626 3.528zm-1.184-23.9a.813.813 0 01.8.921L25 49.471v.041c0 .1.007.192.017.279v.057c.012.087.025.173.042.255v.019c.018.078.042.184.076.287v.007c.033.1.067.19.1.278v.011a3.403 3.403 0 00.286.522 2.968 2.968 0 00.183.24l.008.009.006.006a4.183 4.183 0 00.19.207l.021.02.026.024a2.394 2.394 0 00.216.189l.009.006.027.02.02.015c.047.036.1.074.148.109a1.3 1.3 0 00.086.052l.029.017.036.022.008.005c.032.021.066.042.1.061.054.027.11.053.162.077l.023.012.022.011.069.032a4.642 4.642 0 00.264.098h.026a3.165 3.165 0 004.105-2.888.78.78 0 01.087-.319c0-.009.008-.018.012-.027v-.008a.174.174 0 01.011-.024.2.2 0 01.018-.022l.01-.013a.881.881 0 01.093-.121h.006a.806.806 0 01.902-.153l.073.03.014.005.049.02a4.258 4.258 0 001.669.348c.24-.002.48-.023.718-.065h.075c.023 0 .047-.007.071-.012a4.286 4.286 0 001.763-.821l.027-.02.014-.01c.019-.014.038-.027.056-.042l.062-.055.015-.014.021-.019.041-.038.033-.029.014-.013a2.431 2.431 0 00.172-.17l.023-.026a3.963 3.963 0 00.486-.612l.014-.024.027-.045c.194-.311.348-.645.46-.994.018-.058.033-.119.045-.171l.02-.08.018-.068a1.418 1.418 0 00.037-.177v-.023c0-.025.004-.05.011-.076a4.141 4.141 0 00-.142-1.967 7.038 7.038 0 00-.116-.331.749.749 0 01-.05-.193 4.292 4.292 0 00-3.87-2.476.812.812 0 01-.809-.813 6.539 6.539 0 00-4.712-6.265.814.814 0 11.445-1.565 8 8 0 013.17 1.768 6.122 6.122 0 017.956 1.656.815.815 0 01-.649 1.303.81.81 0 01-.65-.326 4.506 4.506 0 00-5.528-1.388 8.135 8.135 0 011.549 4.061 5.94 5.94 0 014.334 2.909 6.539 6.539 0 004.007-6.007c0-.191-.01-.385-.03-.594 0-.05-.01-.1-.016-.148v-.031c-.02-.161-.041-.3-.064-.427l-.031-.168a8.184 8.184 0 00-.14-.546.574.574 0 00-.022-.062l-.021-.061a7.336 7.336 0 00-.153-.419l-.007-.017-.066-.153a7.077 7.077 0 00-.189-.391l-.03-.059c-.01-.02-.021-.045-.033-.065a6.678 6.678 0 00-.291-.481l-.024-.033-.01-.014-.038-.052a6.026 6.026 0 00-.265-.355l-.059-.073-.039-.049-.016-.019c-.1-.11-.184-.207-.271-.3l-.069-.072-.018-.019-.035-.037a7.027 7.027 0 00-.38-.347 7.548 7.548 0 00-.239-.186l-.025-.019a3.05 3.05 0 00-.147-.109c-.1-.07-.2-.144-.318-.214l-.034-.021-.037-.023a6.715 6.715 0 00-.811-.42.159.159 0 01-.034-.019l-.023-.014a6.451 6.451 0 00-2.864-.501h-.042a.814.814 0 01-.034-1.626c.152-.008.3-.009.422-.009a8.055 8.055 0 012.752.481l.044-.02c.046-.04.091-.079.137-.123a5.542 5.542 0 001.683-3.662 5.616 5.616 0 00-.013-.817 5.65 5.65 0 00-.094-.617 5.522 5.522 0 00-4.362-4.333.8.8 0 01-.6-.5.815.815 0 01.094-.776 4.241 4.241 0 00.759-1.835 4.3 4.3 0 00-4.231-4.961c-.262 0-.524.026-.782.076a.857.857 0 01-.139.013h-.033a.8.8 0 01-.753-.581l-.006-.014a.969.969 0 01-.025-.17 3.17 3.17 0 00-6.335.182v20.792l1.2-.9a.805.805 0 01.491-.167l-.001.005zM16.308 48.808a.81.81 0 01.809.776 3.169 3.169 0 006.339-.15V34.285l-1.2.905a.811.811 0 01-1.295-.734l2.5-24.245a3.149 3.149 0 00-.741-2.004l-.006-.007-.006-.007-.008-.009a2.591 2.591 0 00-.214-.229l-.019-.017-.017-.016c-.048-.044-.1-.094-.158-.143l-.039-.029h-.007l-.009-.006-.03-.023-.071-.064a2.695 2.695 0 00-.085-.064c-.029-.021-.077-.046-.112-.066l-.022-.013-.008-.005h-.007a1.418 1.418 0 00-.113-.069c-.039-.021-.078-.039-.117-.058l-.037-.018-.035-.016-.013-.006-.018-.009-.012-.006a2.527 2.527 0 00-.313-.119h-.013a3.14 3.14 0 00-2.713.4A3.169 3.169 0 0017.2 9.53c-.042.173-.068.35-.079.527a.888.888 0 01-.31.594.814.814 0 01-.501.169h-.086a.514.514 0 01-.062-.005 4.187 4.187 0 00-2.7.383 4.275 4.275 0 00-2.362 3.834 4.22 4.22 0 00.421 1.845c.11.23.24.45.387.658a.813.813 0 01-.5 1.274c-.36.072-.71.178-1.049.318a5.529 5.529 0 00-3.437 5.13 5.449 5.449 0 001.258 3.511c.177.214.37.415.576.6a8.079 8.079 0 012.755-.481c.172 0 .3 0 .422.009a.816.816 0 01.771.852.808.808 0 01-.8.774h-.05a6.423 6.423 0 00-2.864.501l-.025.015a.205.205 0 01-.03.019c-.276.12-.543.26-.8.416l-.031.018-.023.015-.032.021c-.1.061-.2.129-.306.206l-.186.139a5.547 5.547 0 00-.672.592l-.027.027-.027.027c-.1.1-.189.2-.279.31l-.075.09-.036.044a6.647 6.647 0 00-.271.365l-.023.03-.01.014a7.613 7.613 0 00-.328.533l-.029.055-.011.022-.022.042a7.13 7.13 0 00-.189.394l-.029.067-.031.071-.013.031c-.051.127-.1.269-.154.421l-.033.1-.008.022a6.381 6.381 0 00-.162.665l-.008.048c-.029.153-.051.3-.066.428v.031c-.006.049-.013.1-.016.148A4.555 4.555 0 005 36.04a6.557 6.557 0 004.012 6.006 5.94 5.94 0 014.334-2.909 8.122 8.122 0 011.537-4.065 4.516 4.516 0 00-5.517 1.392.807.807 0 01-1.136.162.814.814 0 01-.161-1.139 6.133 6.133 0 017.944-1.662 8.04 8.04 0 012.851-1.658.814.814 0 01.513 1.543 6.505 6.505 0 00-4.447 6.184c0 .45-.365.813-.814.813a4.3 4.3 0 00-3.868 2.476.755.755 0 01-.049.192c-.02.048-.037.1-.053.146l-.007.02-.011.033-.024.067a4.282 4.282 0 002.4 5.31c.076.033.157.06.227.084l.017.006.061.023h.012l.074.026a4.526 4.526 0 001.271.193c.622 0 1.237-.136 1.8-.4a.506.506 0 01.087-.031l.02-.006a.792.792 0 01.235-.038z",
  fill: "#595959"
}, null, -1);
const _hoisted_5$2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M30.506 25.713a7.664 7.664 0 011.432 3.466.811.811 0 001.606-.234A9.454 9.454 0 0026 21.057v1.67a7.816 7.816 0 013.292 1.68 2.273 2.273 0 01-2.032 1.805h-.011a.814.814 0 000 1.627h.016a3.605 3.605 0 003.241-2.126M19.032 18.942a.814.814 0 00.781 1.04.814.814 0 00.779-.587 2.488 2.488 0 011.138-1.487l.19-1.851a4.206 4.206 0 00-2.888 2.885M27.935 19.557a.811.811 0 001.007.555.815.815 0 00.554-1.008A4.346 4.346 0 0026 16.057v1.672a2.639 2.639 0 011.935 1.828",
  fill: "#595959"
}, null, -1);
const _hoisted_6$2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M22.928 34.837c.252 0 .501.055.73.16.545.234.903.765.914 1.358v21.7l3.894-26.963-1.7 1.188a1.77 1.77 0 01-1.717.144 1.514 1.514 0 01-.906-1.364V1.055l-3.915 35.288.521-.362 1.2-.84c.29-.199.633-.303.984-.3",
  stroke: "#FFF",
  fill: "#BFBFBF"
}, null, -1);
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["mx-auto relative", $props.large ? "h-20 w-20" : "h-10 w-10"])
  }, [
    createElementVNode("span", {
      style: { "border-color": "rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.4)" },
      class: normalizeClass(["inline-block border-2 rounded-full align-text-bottom animate-spin animate-animated", $props.large ? "h-20 w-20" : "h-10 w-10"])
    }, null, 2),
    createElementVNode("span", _hoisted_1$7, [
      renderSlot(_ctx.$slots, "default", {}, () => [
        (openBlock(), createElementBlock("svg", {
          class: normalizeClass($props.large ? "h-12 w-12" : "h-6 w-6"),
          viewBox: "0 0 48 59",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          createElementVNode("g", _hoisted_2$6, [
            createElementVNode("path", {
              class: normalizeClass({ "animate-pulse": $props.pulse }),
              d: "M45.244 24.072a9.4 9.4 0 00-4.285-7.872 8.117 8.117 0 00-6.683-9.358 6.97 6.97 0 00-10.19-2.53A6.97 6.97 0 0013.9 6.842 8.123 8.123 0 007.211 16.2a9.378 9.378 0 00-3.165 12.319A10.3 10.3 0 001 35.857c0 .079.004.157.013.235.075 3.47 1.89 6.67 4.829 8.517v.2c0 .233.027.465.081.691a8.092 8.092 0 008.057 7.421h.177a6.966 6.966 0 009.931 2.074 6.964 6.964 0 009.929-2.074h.177a8.092 8.092 0 008.057-7.42 3 3 0 00.082-.692v-.2a10.318 10.318 0 004.831-8.518c.008-.078.012-.157.012-.235a10.3 10.3 0 00-3.046-7.34 9.33 9.33 0 001.114-4.444z",
              fill: "#8C8C8C"
            }, null, 2),
            _hoisted_3$6,
            _hoisted_4$3,
            _hoisted_5$2,
            _hoisted_6$2
          ])
        ], 2))
      ])
    ])
  ], 2);
}
const Loading = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$5]]);
const _sfc_main$e = {
  name: "Notifier",
  emits: ["close"],
  setup() {
    return useNotifier();
  }
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_n_notify = resolveComponent("n-notify");
  return openBlock(), createBlock(_component_n_notify, {
    title: _ctx.title,
    message: _ctx.message,
    show: _ctx.opened,
    onClose: _ctx.close
  }, null, 8, ["title", "message", "show", "onClose"]);
}
const Notifier = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$4]]);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k;
    for (k in obj) {
      if (hasOwnProp(obj, k)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === void 0;
}
function isNumber(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn(arr[i], i));
  }
  return res;
}
function extend(a, b) {
  for (var i in b) {
    if (hasOwnProp(b, i)) {
      a[i] = b[i];
    }
  }
  if (hasOwnProp(b, "toString")) {
    a.toString = b.toString;
  }
  if (hasOwnProp(b, "valueOf")) {
    a.valueOf = b.valueOf;
  }
  return a;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m) {
  if (m._pf == null) {
    m._pf = defaultParsingFlags();
  }
  return m._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t = Object(this), len = t.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t && fun.call(this, t[i], i, t)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m) {
  var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
  if (isNowValid) {
    flags = getParsingFlags(m);
    parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    });
    isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
  }
  if (Object.isFrozen == null || !Object.isFrozen(m)) {
    m._isValid = isNowValid;
  } else {
    return isNowValid;
  }
  return m._isValid;
}
function createInvalid(flags) {
  var m = createUTC(NaN);
  if (flags != null) {
    extend(getParsingFlags(m), flags);
  } else {
    getParsingFlags(m).userInvalidated = true;
  }
  return m;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from2[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn) {
  var firstTime = true;
  return extend(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn(
        msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn.apply(this, arguments);
  }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name, msg);
  }
  if (!deprecations[name]) {
    warn(msg);
    deprecations[name] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config) {
  var prop, i;
  for (i in config) {
    if (hasOwnProp(config, i)) {
      prop = config[i];
      if (isFunction(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
        res[prop] = {};
        extend(res[prop], parentConfig[prop]);
        extend(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
      res[prop] = extend({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys;
if (Object.keys) {
  keys = Object.keys;
} else {
  keys = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction(output) ? output.call(mom, now2) : output;
}
function zeroFill(number, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i, length;
  for (i = 0, length = array.length; i < length; i++) {
    if (formatTokenFunctions[array[i]]) {
      array[i] = formatTokenFunctions[array[i]];
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }
  return function(mom) {
    var output = "", i2;
    for (i2 = 0; i2 < length; i2++) {
      output += isFunction(array[i2]) ? array[i2].call(mom, format2) : array[i2];
    }
    return output;
  };
}
function formatMoment(m, format2) {
  if (!m.isValid()) {
    return m.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number) {
  return this._ordinal.replace("%d", number);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number, withoutSuffix, string, isFuture) {
  var output = this._relativeTime[string];
  return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(unitsObj) {
  var units = [], u;
  for (u in unitsObj) {
    if (hasOwnProp(unitsObj, u)) {
      units.push({ unit: u, priority: priorities[u] });
    }
  }
  units.sort(function(a, b) {
    return a.priority - b.priority;
  });
  return units;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s) {
  return regexEscape(
    s.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(number) {
  if (number < 0) {
    return Math.ceil(number) || 0;
  } else {
    return Math.floor(number);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
var tokens = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config._a, config, token2);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var y = this.year();
  return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get(this, unit);
    }
  };
}
function get(mom, unit) {
  if (!mom.isValid()) {
    return NaN;
  }
  var d = mom._d, isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
    case "Seconds":
      return isUTC ? d.getUTCSeconds() : d.getSeconds();
    case "Minutes":
      return isUTC ? d.getUTCMinutes() : d.getMinutes();
    case "Hours":
      return isUTC ? d.getUTCHours() : d.getHours();
    case "Date":
      return isUTC ? d.getUTCDate() : d.getDate();
    case "Day":
      return isUTC ? d.getUTCDay() : d.getDay();
    case "Month":
      return isUTC ? d.getUTCMonth() : d.getMonth();
    case "FullYear":
      return isUTC ? d.getUTCFullYear() : d.getFullYear();
    default:
      return NaN;
  }
}
function set$1(mom, unit, value) {
  var d, isUTC, year, month, date;
  if (!mom.isValid() || isNaN(value)) {
    return;
  }
  d = mom._d;
  isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
    case "Seconds":
      return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
    case "Minutes":
      return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
    case "Hours":
      return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
    case "Date":
      return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
    case "FullYear":
      break;
    default:
      return;
  }
  year = value;
  month = mom.month();
  date = mom.date();
  date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
  void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
function mod(n, x) {
  return (n % x + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m, format2) {
  if (!m) {
    return isArray(this._months) ? this._months : this._months["standalone"];
  }
  return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
}
function localeMonthsShort(m, format2) {
  if (!m) {
    return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber(value)) {
        return mom;
      }
    }
  }
  var month = value, date = mom.date();
  date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
  void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortP = regexEscape(this.monthsShort(mom, ""));
    longP = regexEscape(this.months(mom, ""));
    shortPieces.push(shortP);
    longPieces.push(longP);
    mixedPieces.push(longP);
    mixedPieces.push(shortP);
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
function createDate(y, m, d, h2, M, s, ms) {
  var date;
  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h2, M, s, ms);
    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h2, M, s, ms);
  }
  return date;
}
function createUTCDate(y) {
  var date, args;
  if (y < 100 && y >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y + 400;
    date = new Date(Date.UTC.apply(null, args));
    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(null, arguments));
  }
  return date;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n) {
  return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m, format2) {
  var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
}
function localeWeekdaysShort(m) {
  return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m) {
  return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = get(this, "Day");
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config) {
  array[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i = 0, j, next, locale2, split;
  while (i < names.length) {
    split = normalizeLocale(names[i]).split("-");
    j = split.length;
    next = normalizeLocale(names[i + 1]);
    next = next ? next.split("-") : null;
    while (j > 0) {
      locale2 = loadLocale(split.slice(0, j).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
        break;
      }
      j--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name) {
  return !!(name && name.match("^[^/\\\\]*$"));
}
function loadLocale(name) {
  var oldLocale = null, aliasedRequire;
  if (locales[name] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name);
      getSetGlobalLocale(oldLocale);
    } catch (e) {
      locales[name] = null;
    }
  }
  return locales[name];
}
function getSetGlobalLocale(key, values) {
  var data;
  if (key) {
    if (isUndefined(values)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name;
    if (locales[name] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name,
            config
          });
          return null;
        }
      }
    }
    locales[name] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name]) {
      localeFamilies[name].forEach(function(x) {
        defineLocale(x.name, x.config);
      });
    }
    getSetGlobalLocale(name);
    return locales[name];
  } else {
    delete locales[name];
    return null;
  }
}
function updateLocale(name, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name] != null && locales[name].parentLocale != null) {
      locales[name].set(mergeConfigs(locales[name]._config, config));
    } else {
      tmpLocale = loadLocale(name);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name];
      locales[name] = locale2;
    }
    getSetGlobalLocale(name);
  } else {
    if (locales[name] != null) {
      if (locales[name].parentLocale != null) {
        locales[name] = locales[name].parentLocale;
        if (name === getSetGlobalLocale()) {
          getSetGlobalLocale(name);
        }
      } else if (locales[name] != null) {
        delete locales[name];
      }
    }
  }
  return locales[name];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(m) {
  var overflow, a = m._a;
  if (a && getParsingFlags(m).overflow === -2) {
    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m).overflow = overflow;
  }
  return m;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match) {
    getParsingFlags(config).iso = true;
    for (i = 0, l = isoDatesLen; i < l; i++) {
      if (isoDates[i][1].exec(match[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match[3]) {
      for (i = 0, l = isoTimesLen; i < l; i++) {
        if (isoTimes[i][1].exec(match[3])) {
          timeFormat = (match[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match[4]) {
      if (tzRegex.exec(match[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result.push(parseInt(secondStr, 10));
  }
  return result;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s) {
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m = hm % 100, h2 = (hm - m) / 100;
    return h2 * 60 + m;
  }
}
function configFromRFC2822(config) {
  var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match) {
    parsedArray = extractFromRFC2822Strings(
      match[4],
      match[3],
      match[2],
      match[5],
      match[6],
      match[7]
    );
    if (!checkWeekday(match[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match[8], match[9], match[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config) {
    config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
  }
);
function defaults(a, b, c) {
  if (a != null) {
    return a;
  }
  if (b != null) {
    return b;
  }
  return c;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i, date, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date.getUTCMonth();
    config._a[DATE] = date.getUTCDate();
  }
  for (i = 0; i < 3 && config._a[i] == null; ++i) {
    config._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w = config._w;
  if (w.GG != null || w.W != null || w.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(
      w.GG,
      config._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults(w.W, 1);
    weekday = defaults(w.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
    week = defaults(w.w, curWeek.week);
    if (w.d != null) {
      weekday = w.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w.e != null) {
      weekday = w.e + dow;
      if (w.e < 0 || w.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string.substr(0, string.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string = string.slice(
        string.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
  if (string.length > 0) {
    getParsingFlags(config).unusedInput.push(string);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = void 0;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(
    config._locale,
    config._a[HOUR],
    config._meridiem
  );
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
  config._a = map(
    [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format2 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config._d = input;
  } else if (isArray(format2)) {
    configFromStringAndArray(config);
  } else if (format2) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray(input)) {
    config._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject(input)) {
    configFromObject(config);
  } else if (isNumber(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
    input = void 0;
  }
  c._isAMomentObject = true;
  c._useUTC = c._isUTC = isUTC;
  c._l = locale2;
  c._i = input;
  c._f = format2;
  c._strict = strict;
  return createFromConfig(c);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn, moments) {
  var res, i;
  if (moments.length === 1 && isArray(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m) {
  var key, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key in m) {
    if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number) {
  if (number < 0) {
    return Math.round(-1 * number) * -1;
  } else {
    return Math.round(number);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string) {
  var matches = (string || "").match(matcher), chunk, parts, minutes2;
  if (matches === null) {
    return null;
  }
  chunk = matches[matches.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m) {
  return -Math.round(m._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset2, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c = {}, other;
  copyConfig(c, this);
  c = prepareConfig(c);
  if (c._a) {
    other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration = input, match = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber(input) || !isNaN(+input)) {
    duration = {};
    if (key) {
      duration[key] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match = aspNetRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match[DATE]) * sign2,
      h: toInt(match[HOUR]) * sign2,
      m: toInt(match[MINUTE]) * sign2,
      s: toInt(match[SECOND]) * sign2,
      ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match = isoRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match[2], sign2),
      M: parseIso(match[3], sign2),
      w: parseIso(match[4], sign2),
      d: parseIso(match[5], sign2),
      h: parseIso(match[6], sign2),
      m: parseIso(match[7], sign2),
      s: parseIso(match[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(
      createLocal(duration.from),
      createLocal(duration.to)
    );
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base, other) {
  var res = {};
  res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
  if (base.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base, other) {
  var res;
  if (!(base.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base);
  if (base.isBefore(other)) {
    res = positiveMomentsDifference(base, other);
  } else {
    res = positiveMomentsDifference(other, base);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name,
        "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString$1(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString$1(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber(item) && isString$1(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties.length; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(
    output || this.localeData().calendar(format2, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
  if (a.date() < b.date()) {
    return -monthDiff(b, a);
  }
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b - anchor < 0) {
    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
  if (m.year() < 0 || m.year() > 9999) {
    return formatMoment(
      m,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
    }
  }
  return formatMoment(
    m,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key) {
    if (key === void 0) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return new Date(y, m, d).valueOf();
  }
}
function utcStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y, m, d);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m = this;
  return [
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  ];
}
function toObject() {
  var m = this;
  return {
    years: m.year(),
    months: m.month(),
    date: m.date(),
    hours: m.hours(),
    minutes: m.minutes(),
    seconds: m.seconds(),
    milliseconds: m.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config, token2) {
    var era = config._locale.erasParse(input, token2, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config, token2) {
  var match;
  if (config._locale._eraYearOrdinalRegex) {
    match = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m, format2) {
  var i, l, date, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l = eras.length; i < l; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date = hooks(eras[i].since).startOf("day");
        eras[i].since = date.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l, eras = this.eras(), name, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l = eras.length; i < l; ++i) {
    name = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l, dir, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    erasName = regexEscape(eras[i].name);
    erasAbbr = regexEscape(eras[i].abbr);
    erasNarrow = regexEscape(eras[i].narrow);
    namePieces.push(erasName);
    abbrPieces.push(erasAbbr);
    narrowPieces.push(erasNarrow);
    mixedPieces.push(erasName);
    mixedPieces.push(erasAbbr);
    mixedPieces.push(erasNarrow);
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date.getUTCFullYear());
  this.month(date.getUTCMonth());
  this.date(date.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string) {
  return string;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format2, index2, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index2);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index2, field) {
  if (isNumber(format2)) {
    index2 = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index2 != null) {
    return get$1(format2, index2, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index2, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index2 = format2;
    localeSorted = false;
    if (isNumber(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index2 != null) {
    return get$1(format2, (index2 + shift) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1(format2, (i + shift) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index2) {
  return listMonthsImpl(format2, index2, "months");
}
function listMonthsShort(format2, index2) {
  return listMonthsImpl(format2, index2, "monthsShort");
}
function listWeekdays(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number) {
    var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
    return number + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other = createDuration(input, value);
  duration._milliseconds += direction * other._milliseconds;
  duration._days += direction * other._days;
  duration._months += direction * other._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number) {
  if (number < 0) {
    return Math.floor(number);
  } else {
    return Math.ceil(number);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
  return function() {
    return this.isValid() ? this._data[name] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a[2] = withoutSuffix;
  a[3] = +posNegDuration > 0;
  a[4] = locale2;
  return substituteTimeAgo.apply(null, a);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x) {
  return (x > 0) - (x < 0) || +x;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const _hoisted_1$6 = { class: "inline-flex" };
const _hoisted_2$5 = {
  key: 0,
  class: "flex flex-col font-bold text-nerve"
};
const _hoisted_3$5 = { class: "flex flex-nowrap items-center text-nowrap landing-none capitalize" };
const _hoisted_4$2 = /* @__PURE__ */ createElementVNode("svg", {
  class: "ml-1 h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 16"
}, [
  /* @__PURE__ */ createElementVNode("defs"),
  /* @__PURE__ */ createElementVNode("path", {
    fill: "#4a4a4a",
    d: "M6.75 15.35a5.2 5.2 0 01-5.2-5.18 5.2 5.2 0 0110.4 0 5.2 5.2 0 01-5.2 5.18zM5.07 2.05a1.74 1.74 0 013.48 0c0 .73-.45 1.36-1.1 1.61v-.75h.28a.13.13 0 00.12-.12v-1.2a.13.13 0 00-.12-.13H5.89a.13.13 0 00-.12.13v1.2c0 .07.06.13.12.13h.28v.74a1.74 1.74 0 01-1.1-1.61zm7.78 3.32l-1.3-1.29a.19.19 0 10-.27.27l-.58.59a.19.19 0 000 .26l.13.13-.22.23a.2.2 0 000 .28 5.81 5.81 0 00-3.16-1.42v-.47a2.01 2.01 0 001.38-1.9A2.01 2.01 0 006.8.04c-1.11 0-2.01.9-2.01 2a2.01 2.01 0 001.37 1.91v.46a5.81 5.81 0 00-3.26 1.41.2.2 0 00-.02-.26l-.22-.23.13-.13a.19.19 0 000-.26l-.59-.59a.19.19 0 000-.27.19.19 0 00-.26 0L.65 5.37a.19.19 0 10.27.27v-.01l.6.58a.2.2 0 00.27 0l.12-.13.23.23a.2.2 0 00.26.02 5.75 5.75 0 00-1.47 3.84 5.82 5.82 0 0011.64 0c0-1.48-.57-2.83-1.49-3.85.08.07.2.06.28-.01l.23-.22.13.12a.2.2 0 00.27 0l.58-.58h.01a.19.19 0 00.27 0 .19.19 0 000-.26z"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    fill: "#d0021b",
    d: "M6.75 14.68a4.53 4.53 0 01-3.9-2.23l3.9-2.28-.02-4.5h.02a4.52 4.52 0 110 9.01zm0-9.35c-2.68 0-4.87 2.17-4.87 4.84a4.86 4.86 0 009.73 0 4.86 4.86 0 00-4.86-4.84z"
  })
], -1);
const _hoisted_5$1 = {
  key: 0,
  style: { "margin-top": "-3px" }
};
const _hoisted_6$1 = { class: "mr-1 capitalize" };
const _hoisted_7 = {
  key: 2,
  class: "flex items-center gap-2"
};
const _hoisted_8 = /* @__PURE__ */ createElementVNode("span", { class: "text-dust-700" }, "Time remaining:", -1);
const _hoisted_9 = { class: "flex items-center gap-1" };
const _hoisted_10 = { class: "bg-black text-white rounded-md text-xs px-1.5 py-0.5" };
const _hoisted_11 = { class: "bg-black text-white rounded-md text-xs px-1.5 py-0.5" };
const _hoisted_12 = { class: "bg-black text-white rounded-md text-xs px-1.5 py-0.5" };
const __default__$7 = {
  name: "TimeRemaining"
};
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  ...__default__$7,
  props: {
    closed: { type: Boolean, default: false },
    showClosedTime: { type: Boolean, default: false },
    datetime: { default: () => /* @__PURE__ */ new Date() },
    autoUpdate: { type: [Number, Boolean], default: false },
    prefix: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const date = (time) => hooks(time).fromNow();
    const updater = ref(null);
    const getDuration = () => {
      const now2 = hooks(/* @__PURE__ */ new Date());
      const end = hooks(props.datetime);
      const duration2 = hooks.duration(end.diff(now2));
      return {
        days: duration2.days(),
        hours: duration2.hours(),
        minutes: duration2.minutes(),
        seconds: duration2.seconds()
      };
    };
    const duration = ref(getDuration());
    const title = computed(() => {
      return hooks(props.datetime).format("YYYY-MM-DD @ HH:mm");
    });
    const updateDuration = () => {
      duration.value = getDuration();
    };
    const startUpdater = () => {
      if (props.autoUpdate) {
        const autoUpdate = props.autoUpdate === true ? 30 : props.autoUpdate;
        updater.value = setInterval(() => {
          updateDuration();
        }, autoUpdate * 1e3);
      }
    };
    const stopUpdater = () => {
      if (updater.value) {
        clearInterval(updater.value);
        updater.value = null;
      }
    };
    const zLeft = (v) => v < 10 ? `0${v}` : v;
    watch(() => props.autoUpdate, (newValue) => {
      stopUpdater();
      if (newValue) {
        startUpdater();
      }
    });
    watch(() => props.datetime, () => {
      updateDuration();
    });
    const isClosed = computed(() => {
      return props.closed || hooks(props.datetime).isBefore();
    });
    if (duration.value.days === 0 && props.autoUpdate) {
      startUpdater();
    }
    onBeforeUnmount(stopUpdater);
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$6, [
        isClosed.value ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
          createElementVNode("span", _hoisted_3$5, [
            createTextVNode(toDisplayString(_ctx.prefix) + " closed ", 1),
            _hoisted_4$2
          ]),
          _ctx.showClosedTime ? (openBlock(), createElementBlock("small", _hoisted_5$1, [
            createElementVNode("i", null, toDisplayString(title.value), 1)
          ])) : createCommentVNode("", true)
        ])) : duration.value.days > 0 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createElementVNode("b", _hoisted_6$1, toDisplayString(_ctx.prefix) + " closes", 1),
          createTextVNode(toDisplayString(date(_ctx.datetime)), 1)
        ], 64)) : (openBlock(), createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          createElementVNode("span", _hoisted_9, [
            createElementVNode("span", _hoisted_10, toDisplayString(zLeft(duration.value.hours)), 1),
            createTextVNode(": "),
            createElementVNode("span", _hoisted_11, toDisplayString(zLeft(duration.value.minutes)), 1),
            createTextVNode(": "),
            createElementVNode("span", _hoisted_12, toDisplayString(zLeft(duration.value.seconds)), 1)
          ])
        ]))
      ])), [
        [_directive_tooltip, title.value]
      ]);
    };
  }
});
const _sfc_main$c = {
  name: "Toaster",
  emits: ["close"],
  components: { NToast },
  setup() {
    return useToaster();
  }
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NToast = resolveComponent("NToast");
  return openBlock(), createBlock(_component_NToast, {
    active: _ctx.active,
    duration: _ctx.duration,
    type: _ctx.type,
    closable: _ctx.closable,
    dense: _ctx.dense,
    color: _ctx.color,
    "onUpdate:active": _cache[0] || (_cache[0] = (v) => _ctx.active = v)
  }, {
    default: withCtx(() => [
      createTextVNode(toDisplayString(_ctx.message), 1)
    ]),
    _: 1
  }, 8, ["active", "duration", "type", "closable", "dense", "color"]);
}
const Toaster = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$3]]);
const _sfc_main$b = {
  name: "Panel"
};
const _hoisted_1$5 = { class: "border rounded-tl-lg rounded-tr-lg overflow-hidden" };
const _hoisted_2$4 = { class: "flex items-center justify-between px-6 h-14 bg-dust-200" };
const _hoisted_3$4 = { class: "p-6" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("div", _hoisted_2$4, [
      createElementVNode("div", null, [
        renderSlot(_ctx.$slots, "header")
      ]),
      createElementVNode("div", null, [
        renderSlot(_ctx.$slots, "actions")
      ])
    ]),
    createElementVNode("div", _hoisted_3$4, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
const Panel = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$2]]);
const _sfc_main$a = {
  name: "Pagination",
  props: {
    total: [String, Number],
    skip: [String, Number],
    limit: [String, Number]
  }
};
const _hoisted_1$4 = { class: "px-5 py-5 flex flex-col xs:flex-row items-center xs:justify-between" };
const _hoisted_2$3 = { class: "text-xs xs:text-sm text-gray-900" };
const _hoisted_3$3 = { class: "inline-flex mt-4 xs:mt-0 divide-x divide-gray-500" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("span", _hoisted_2$3, " Showing " + toDisplayString($props.skip) + " to " + toDisplayString($props.limit) + " of " + toDisplayString($props.total) + " Entries ", 1),
    createElementVNode("div", _hoisted_3$3, [
      createElementVNode("button", {
        class: "text-sm bg-gray-700 hover:bg-gray-800 text-white font-semibold py-2 px-4 rounded-l",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("prev", { skip: $props.skip, limit: $props.limit, total: $props.total }))
      }, " Prev "),
      createElementVNode("button", {
        class: "text-sm bg-gray-700 hover:bg-gray-800 text-white font-semibold py-2 px-4 rounded-r",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("next", { skip: $props.skip, limit: $props.limit, total: $props.total }))
      }, " Next ")
    ])
  ]);
}
const Pagination = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$1]]);
const _hoisted_1$3 = { class: "flex items-center space-x-2" };
const _hoisted_2$2 = ["for"];
const _hoisted_3$2 = ["id", "name"];
const __default__$6 = {
  name: "Switch"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  ...__default__$6,
  props: {
    label: {},
    modelValue: { type: Boolean },
    activeColor: { default: "nerve" },
    inactiveColor: { default: "dust" },
    icon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    thin: { type: Boolean, default: false },
    id: { default: Math.random().toString(36).substr(2, 9) }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const uid = computed(() => `switch-${1}`);
    const toggle = () => {
      if (!props.disabled) {
        emit("update:modelValue", !props.modelValue);
        emit("change", !props.modelValue);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        _ctx.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: uid.value,
          class: "m-0"
        }, toDisplayString(_ctx.label), 9, _hoisted_2$2)) : createCommentVNode("", true),
        createElementVNode("button", {
          class: normalizeClass([[{
            [`bg-${_ctx.activeColor}`]: _ctx.modelValue,
            [`bg-${_ctx.inactiveColor}`]: !_ctx.modelValue,
            "cursor-not-allowed": _ctx.disabled
          }, _ctx.thin ? "h-4 w-7" : "h-6 w-11"], "relative inline-flex items-center flex-shrink-0 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer focus:outline-none focus:shadow-outline"]),
          id: uid.value,
          name: uid.value,
          "aria-labelledby": "headlessui-switch-label-1",
          "aria-checked": "false",
          role: "switch",
          tabindex: "0",
          type: "button",
          onClick: toggle
        }, [
          createElementVNode("span", {
            class: normalizeClass(["inline-flex transition duration-200 ease-in-out transform bg-white rounded-full items-center justify-center", [
              { "translate-x-0": !_ctx.modelValue },
              _ctx.thin ? { "translate-x-3": _ctx.modelValue } : { "translate-x-5": _ctx.modelValue },
              _ctx.thin ? "w-3 h-3" : "w-5 h-5"
            ]])
          }, [
            _ctx.icon ? (openBlock(), createBlock(unref(Icon), {
              key: 0,
              class: normalizeClass(["text-xs", {
                [`text-${_ctx.activeColor} leading-tight`]: _ctx.modelValue,
                [`text-${_ctx.inactiveColor}`]: !_ctx.modelValue
              }]),
              as: _ctx.modelValue ? "check-solid" : "close"
            }, null, 8, ["class", "as"])) : createCommentVNode("", true)
          ], 2)
        ], 10, _hoisted_3$2)
      ]);
    };
  }
});
const _sfc_main$8 = {
  name: "Expander",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    initialValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots, attrs = {} }) {
    const open = ref(props.initialValue);
    const toggle = () => {
      open.value = !open.value;
    };
    return () => {
      const slot = {
        on: { click: toggle },
        opened: open.value,
        open: open.value,
        toggle
      };
      return h(
        props.tag,
        attrs,
        [
          slots.activator ? slots.activator(slot) : null,
          open.value && slots.default && slots.default(slot),
          slots.footer ? slots.footer(slot) : null
        ]
      );
    };
  }
};
const _sfc_main$7 = {
  name: "Scalator",
  props: {
    offset: {
      type: [Number, String],
      default: 100
    }
  },
  emits: ["updated"],
  setup(props, { emit }) {
    const position = ref(0);
    const container = ref(null);
    const { width } = useElementSize(container);
    const containerWidth = computed(() => width.value - props.offset);
    const { isSwiping, distanceX, direction } = usePointerSwipe(container, {
      onSwipe(e) {
        if (containerWidth.value) {
          if (distanceX.value <= 0) {
            const distance = Math.abs(distanceX.value);
            const n = distance / containerWidth.value * 100;
            position.value = n <= 100 ? n >= 0 ? n : 0 : 100;
            emit("updated", position.value);
          }
        }
      }
    });
    return { container, isSwiping, direction, distanceX, position };
  }
};
const _hoisted_1$2 = { ref: "container" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    renderSlot(_ctx.$slots, "default", { position: $setup.position })
  ], 512);
}
const Scalator = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render]]);
var _a;
const isClient = typeof window !== "undefined";
const isString = (val) => typeof val === "string";
const noop = () => {
};
const isIOS = isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function resolveUnref(r) {
  return typeof r === "function" ? r() : unref(r);
}
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
function resolveRef(r) {
  return typeof r === "function" ? computed(r) : ref(r);
}
function unrefElement(elRef) {
  var _a2;
  const plain = resolveUnref(elRef);
  return (_a2 = plain == null ? void 0 : plain.$el) != null ? _a2 : plain;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...args) {
  let target;
  let events;
  let listeners;
  let options;
  if (isString(args[0]) || Array.isArray(args[0])) {
    [events, listeners, options] = args;
    target = defaultWindow;
  } else {
    [target, events, listeners, options] = args;
  }
  if (!target)
    return noop;
  if (!Array.isArray(events))
    events = [events];
  if (!Array.isArray(listeners))
    listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options2) => {
    el.addEventListener(event, listener, options2);
    return () => el.removeEventListener(event, listener, options2);
  };
  const stopWatch = watch(() => [unrefElement(target), resolveUnref(options)], ([el, options2]) => {
    cleanup();
    if (!el)
      return;
    cleanups.push(...events.flatMap((event) => {
      return listeners.map((listener) => register(el, event, listener, options2));
    }));
  }, { immediate: true, flush: "post" });
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
const _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
const globalKey = "__vueuse_ssr_handlers__";
_global[globalKey] = _global[globalKey] || {};
const UseElementVisibility = /* @__PURE__ */ defineComponent({
  name: "UseElementVisibility",
  props: ["as"],
  setup(props, { slots }) {
    const target = ref();
    const data = reactive({
      isVisible: useElementVisibility(target)
    });
    return () => {
      if (slots.default)
        return h(props.as || "div", { ref: target }, slots.default(data));
    };
  }
});
function checkOverflowScroll(ele) {
  const style = window.getComputedStyle(ele);
  if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientHeight < ele.scrollHeight || style.overflowY === "auto" && ele.clientWidth < ele.scrollWidth) {
    return true;
  } else {
    const parent = ele.parentNode;
    if (!parent || parent.tagName === "BODY")
      return false;
    return checkOverflowScroll(parent);
  }
}
function preventDefault(rawEvent) {
  const e = rawEvent || window.event;
  const _target = e.target;
  if (checkOverflowScroll(_target))
    return false;
  if (e.touches.length > 1)
    return true;
  if (e.preventDefault)
    e.preventDefault();
  return false;
}
function useScrollLock(element, initialState = false) {
  const isLocked = ref(initialState);
  let stopTouchMoveListener = null;
  let initialOverflow;
  watch(resolveRef(element), (el) => {
    if (el) {
      const ele = el;
      initialOverflow = ele.style.overflow;
      if (isLocked.value)
        ele.style.overflow = "hidden";
    }
  }, {
    immediate: true
  });
  const lock = () => {
    const ele = resolveUnref(element);
    if (!ele || isLocked.value)
      return;
    if (isIOS) {
      stopTouchMoveListener = useEventListener(ele, "touchmove", (e) => {
        preventDefault(e);
      }, { passive: false });
    }
    ele.style.overflow = "hidden";
    isLocked.value = true;
  };
  const unlock = () => {
    const ele = resolveUnref(element);
    if (!ele || !isLocked.value)
      return;
    isIOS && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
    ele.style.overflow = initialOverflow;
    isLocked.value = false;
  };
  tryOnScopeDispose(unlock);
  return computed({
    get() {
      return isLocked.value;
    },
    set(v) {
      if (v)
        lock();
      else
        unlock();
    }
  });
}
const onScrollLock = () => {
  let isMounted = false;
  const state = ref(false);
  return (el, binding) => {
    state.value = binding.value;
    if (isMounted)
      return;
    isMounted = true;
    const isLocked = useScrollLock(el, binding.value);
    watch(state, (v) => isLocked.value = v);
  };
};
onScrollLock();
const _hoisted_1$1 = ["onClick"];
const _hoisted_2$1 = { class: "inline-flex items-center" };
const _hoisted_3$1 = /* @__PURE__ */ createElementVNode("br", null, null, -1);
const _hoisted_4$1 = { class: "font-normal" };
const _hoisted_5 = { class: "text-dust-800 px-1 mt-4 mb-2" };
const _hoisted_6 = {
  key: 0,
  class: "flex-1"
};
const __default__$5 = {
  name: "FlexTable"
};
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  props: {
    header: { default: () => [] },
    items: { default: () => [] },
    rowClass: { default: "border border-dust-300 rounded-md" },
    headerClass: { default: "" },
    hideHeader: { type: Boolean, default: false },
    groupBy: { type: [String, Function], default: null },
    noResultsText: { default: "No results found" },
    grouped: { type: Boolean, default: false },
    activeClass: { default: "bg-blue-100 border-blue" },
    highlight: { type: Function, default: () => false },
    virtual: { type: Boolean, default: false }
  },
  emits: ["selected"],
  setup(__props) {
    const props = __props;
    const groups = computed(() => {
      if (props.groupBy) {
        const grouped = groupBy(props.items, props.groupBy);
        return grouped.map((item, title) => ({ item, title }));
      }
      return props.grouped ? props.items : [{ items: props.items }];
    });
    const isGrouped = computed(() => props.groupBy || props.grouped);
    const responsive = useResponsive();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        renderSlot(_ctx.$slots, "header", {}, () => [
          !_ctx.hideHeader ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass([_ctx.headerClass, "hidden sm:flex justify-between text-dust-800 font-bold leading-5 mb-4 items-start"])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.header, (col, i) => {
              return openBlock(), createElementBlock("div", {
                key: `header-${i}`,
                class: normalizeClass(["px-1", { "cursor-pointer hover:underline": col.selectable, "border-b border-dust-500 pb-2": isGrouped.value }]),
                style: normalizeStyle({ flex: col.grow || 1, "justify-content": col.align || "left" }),
                onClick: ($event) => col.selectable && _ctx.$emit(`selected`, col)
              }, [
                renderSlot(_ctx.$slots, `header:${col.value || col.name}`, normalizeProps(guardReactiveProps(col)), () => [
                  createElementVNode("span", _hoisted_2$1, [
                    col.icon ? (openBlock(), createBlock(unref(Icon), {
                      key: 0,
                      as: col.icon,
                      class: "mr-2"
                    }, null, 8, ["as"])) : createCommentVNode("", true),
                    createTextVNode(" " + toDisplayString(col.text), 1)
                  ]),
                  col.subtext ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    _hoisted_3$1,
                    createElementVNode("small", _hoisted_4$1, toDisplayString(col.subtext), 1)
                  ], 64)) : createCommentVNode("", true)
                ])
              ], 14, _hoisted_1$1);
            }), 128))
          ], 2)) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "before"),
        (openBlock(true), createElementBlock(Fragment, null, renderList(groups.value, (group, i) => {
          return openBlock(), createElementBlock("div", {
            key: `group-${i}`
          }, [
            (_ctx.grouped || unref(groupBy)) && group.title ? renderSlot(_ctx.$slots, "group-header", {
              key: 0,
              group
            }, () => [
              createElementVNode("h3", _hoisted_5, toDisplayString(group.title), 1)
            ]) : createCommentVNode("", true),
            unref(responsive).sm ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(group.items, (item, i2) => {
              return openBlock(), createBlock(unref(UseElementVisibility), {
                key: `item-${i2}`,
                class: normalizeClass(["flex flex-col mb-3 py-3 px-4", [_ctx.rowClass, _ctx.highlight({ item, group }) && _ctx.activeClass]])
              }, {
                default: withCtx(({ isVisible }) => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.header, (col, i3) => {
                    return openBlock(), createElementBlock("div", {
                      key: `col-${i3}`,
                      class: "flex gap-4 items-center mb-3"
                    }, [
                      col.text && (col.value || col.name) !== "user" ? (openBlock(), createElementBlock("div", _hoisted_6, [
                        createElementVNode("strong", null, toDisplayString(col.text), 1)
                      ])) : createCommentVNode("", true),
                      createElementVNode("div", null, [
                        renderSlot(_ctx.$slots, `col:${col.value || col.name}`, {
                          visible: isVisible,
                          item,
                          header: col,
                          group,
                          highlight: _ctx.highlight({ item, group }),
                          index: i3
                        }, () => [
                          createTextVNode(toDisplayString(item[col.value || col.name]), 1)
                        ])
                      ])
                    ]);
                  }), 128)),
                  renderSlot(_ctx.$slots, `footer`, {
                    visible: isVisible,
                    item,
                    headers: _ctx.header,
                    group,
                    highlight: _ctx.highlight({ item, group }),
                    index: i2,
                    slots: _ctx.$slots
                  })
                ]),
                _: 2
              }, 1032, ["class"]);
            }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(group.items, (item, index2) => {
              return openBlock(), createBlock(unref(UseElementVisibility), {
                key: `item-${index2}`,
                class: normalizeClass({ "h-15": _ctx.virtual })
              }, {
                default: withCtx(({ isVisible }) => [
                  (_ctx.virtual ? isVisible : true) ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(["font-narrow p-2 flex justify-between items-center mb-3 hover:bg-dust-50", [_ctx.rowClass, _ctx.highlight({ item, group }) && _ctx.activeClass]])
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.header, (col, i2) => {
                      return openBlock(), createElementBlock("div", {
                        key: `col-${i2}`,
                        class: "px-1",
                        style: normalizeStyle({ flex: col.grow || 1, "justify-content": col.align || "left" })
                      }, [
                        renderSlot(_ctx.$slots, `col:${col.value || col.name}`, {
                          visible: isVisible,
                          item,
                          header: col,
                          group,
                          highlight: _ctx.highlight({ item, group }),
                          index: i2
                        }, () => [
                          createTextVNode(toDisplayString(item[col.value || col.name]), 1)
                        ])
                      ], 4);
                    }), 128))
                  ], 2)) : createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class"]);
            }), 128)),
            group.items && !group.items.length ? renderSlot(_ctx.$slots, "no-results", {
              key: 3,
              group
            }, () => [
              createElementVNode("div", {
                class: normalizeClass([_ctx.rowClass, "flex flex-row justify-center text-dust mb-3 py-4"])
              }, [
                createElementVNode("span", null, toDisplayString(_ctx.noResultsText), 1)
              ], 2)
            ]) : createCommentVNode("", true)
          ]);
        }), 128))
      ]);
    };
  }
});
const __default__$4 = {
  name: "Bubble"
};
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  props: {
    as: {
      type: String,
      default: "span"
    },
    color: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass([{ "animate-animated animate-tada": __props.animated, [`bg-${__props.color || "dust"}-500`]: true }, "inline-flex px-2 py-1 leading-none text-white text-xs whitespace-nowrap rounded-lg shadow relative"])
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createTextVNode(toDisplayString(__props.label), 1)
        ])
      ], 2);
    };
  }
});
const _hoisted_1 = {
  key: 0,
  class: "pyro"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("div", { class: "before" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("div", { class: "after" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
const __default__$3 = {
  name: "Fireworks"
};
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  props: {
    firing: { type: Boolean, default: false },
    seconds: { default: 3 }
  },
  emits: ["update:firing"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const timeout = ref(null);
    const show = ref(props.firing);
    const stop = () => {
      show.value = false;
    };
    watch(show, (value) => {
      if (value) {
        timeout.value = setTimeout(() => {
          show.value = false;
        }, props.seconds * 1e3);
      } else if (timeout.value) {
        clearTimeout(timeout.value);
      }
      emit("update:firing", value);
    }, { immediate: true });
    watch(() => props.firing, (value) => {
      if (value) {
        show.value = true;
      }
    }, { immediate: true });
    const trigger = () => {
      show.value = true;
      emit("update:firing", show.value);
    };
    const toggle = () => {
      show.value = !show.value;
      emit("update:firing", show.value);
    };
    onUnmounted(() => {
      stop();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        show.value ? (openBlock(), createElementBlock("div", _hoisted_1, _hoisted_4)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {
          on: { click: toggle },
          stop,
          trigger
        })
      ], 64);
    };
  }
});
const Fireworks_vue_vue_type_style_index_0_lang = "";
const __default__$2 = {
  name: "Picture"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  props: {
    src: String,
    alt: String,
    srcs: {
      type: Array,
      default: () => []
    },
    aspect: {
      type: String,
      default: "4/9"
    },
    fallback: {
      type: String,
      default: "https://bignerve.com/img/challenge-image-defaults/challenge-preview-placeholder.svg"
    }
  },
  setup(__props) {
    const visible = ref(false);
    const target = ref(null);
    const props = __props;
    const isVisible = useElementVisibility(target);
    const computedStyle = computed(() => {
      const images = [props.src, ...props.srcs, props.fallback].filter(Boolean);
      return visible.value ? {
        "aspect-ratio": props.aspect,
        "background-image": images.map((img) => `url(${img})`).join(", ")
      } : null;
    });
    watch(isVisible, (value) => {
      if (value && !visible.value) {
        visible.value = true;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "target",
        ref: target,
        style: normalizeStyle(computedStyle.value),
        class: "bg-dust-100 overflow-hide flex-none bg-center bg-cover bg-no-repeat overflow-hidden w-full"
      }, null, 4);
    };
  }
});
const __default__$1 = {
  name: "StarRating"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  props: {
    modelValue: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    increment: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: "rater"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    inactiveColor: {
      type: String,
      default: "white"
    },
    disabledColor: {
      type: String,
      default: "dust"
    },
    formatTooltip: {
      type: Function,
      default: (v) => v
    }
  },
  emits: ["update:modelValue", "change", "hovered"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const hovered = ref(0);
    const readOnly = computed(() => props.disabled);
    const currentColor = computed(() => {
      return props.disabled ? `text-${props.disabledColor}` : `text-${props.color}`;
    });
    const computedTooltip = computed(() => {
      return {
        content: props.formatTooltip(String(props.disabled ? props.modelValue : hovered.value)),
        showTriggers: ["hover"],
        hideTriggers: ["hover"],
        placement: "top",
        disabled: !props.tooltip
      };
    });
    const update = (value) => {
      if (!props.disabled) {
        emit("update:modelValue", value);
        emit("change", value);
      }
    };
    const hover = (value) => {
      hovered.value = Number(numeric(value, 1));
      emit("hovered", value);
    };
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return withDirectives((openBlock(), createElementBlock("div", {
        class: "vue-star-rating",
        onMouseleave: _cache[0] || (_cache[0] = ($event) => hover(__props.modelValue || 0))
      }, [
        createVNode(unref(VStarRating), {
          rating: __props.modelValue,
          "show-rating": false,
          "rounded-corners": true,
          increment: __props.increment,
          "read-only": readOnly.value,
          "max-rating": __props.max,
          clearable: __props.clearable,
          "fixed-points": 1,
          class: normalizeClass(currentColor.value),
          "border-width": 5,
          padding: 0,
          "inactive-color": __props.inactiveColor,
          starSize: 25,
          "active-color": "currentColor",
          "active-border-color": "currentColor",
          ref: "start",
          "onHover:rating": hover,
          "onUpdate:rating": update
        }, null, 8, ["rating", "increment", "read-only", "max-rating", "clearable", "class", "inactive-color"])
      ], 32)), [
        [_directive_tooltip, computedTooltip.value]
      ]);
    };
  }
});
const StarRating_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Markdown",
  props: {
    tag: { default: "div" },
    code: { default: "" },
    inline: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const innerHTML = ref("");
    const wantsList = ref(false);
    const renderMarkdown = (code) => {
      var _a2;
      if (!code) {
        if ((slots.default || []).length > 0) {
          const child = (_a2 = slots == null ? void 0 : slots.default) == null ? void 0 : _a2.call(slots)[0];
          code = child.text || child.children[0].text;
        }
      }
      wantsList.value = Array.isArray(code);
      if (Array.isArray(code) && wantsList.value) {
        code = code == null ? void 0 : code.map((c) => `- ${c}
`).join("");
      }
      if (typeof code !== "string") {
        console.warn(`Invalid type ${typeof code}, expected string`, code);
        code = "";
      }
      innerHTML.value = toHTML(code, {
        inline: props.inline
      });
    };
    watch(() => props.code, (newValue) => {
      renderMarkdown(newValue);
    }, { immediate: true });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        class: normalizeClass(["is-markdown break-words", { "mb-4": wantsList.value }]),
        innerHTML: innerHTML.value
      }, null, 8, ["class", "innerHTML"]);
    };
  }
});
const __default__ = {
  name: "Copy"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    content: { type: [String, Function], default: "" },
    class: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const { copy, copied, isSupported } = useClipboard();
    const handle = () => {
      const content = typeof props.content === "function" ? props.content({ isSupported }) : props.content;
      copy(content);
    };
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "activator", {
        on: { click: handle },
        copied: unref(copied),
        isSupported: unref(isSupported)
      }, () => [
        createVNode(Icon, {
          as: unref(copied) ? "check-solid" : "clone-regular",
          class: normalizeClass(["cursor-pointer", _ctx.class]),
          onClick: handle
        }, null, 8, ["as", "class"])
      ]);
    };
  }
});
const ShareNetwork = {
  name: "ShareNetwork",
  props: {
    /**
     * Name of the network to display.
     */
    network: {
      type: String,
      required: true
    },
    /**
     * URL of the content to share.
     */
    url: {
      type: String,
      required: true
    },
    /**
     * Title of the content to share.
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Description of the content to share.
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Quote content, used for Facebook.
     */
    quote: {
      type: String,
      default: ""
    },
    /**
     * Hashtags, used for Twitter and Facebook.
     */
    hashtags: {
      type: String,
      default: ""
    },
    /**
     * Twitter user, used for Twitter
     * @var string
     */
    twitterUser: {
      type: String,
      default: ""
    },
    /**
     * Media to share, used for Pinterest
     */
    media: {
      type: String,
      default: ""
    },
    /**
     * HTML tag used by the Network component.
     */
    tag: {
      type: String,
      default: "a"
    },
    /**
     * Properties to configure the popup window.
     */
    popup: {
      type: Object,
      default: () => ({
        width: 626,
        height: 436
      })
    }
  },
  setup(props, { attrs, slots }) {
    const { share, touch } = usePopup();
    const { networks } = useNetworks();
    const key = computed(() => props.network.toLowerCase());
    const rawLink = computed(() => {
      const ua = navigator.userAgent.toLowerCase();
      if (key.value === "sms" && (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1)) {
        return networks.value[key.value].replace(":?", ":&");
      }
      return networks.value[key.value];
    });
    const encodedHashtags = computed(() => {
      if (key.value === "facebook" && props.hashtags.length) {
        return "%23" + props.hashtags.split(",")[0];
      }
      return props.hashtags;
    });
    const shareLink = computed(() => {
      let link = rawLink.value;
      if (key.value === "twitter") {
        if (!props.hashtags.length)
          link = link.replace("&hashtags=@h", "");
        if (!props.twitterUser.length)
          link = link.replace("@tu", "");
      }
      return link.replace(/@tu/g, "&via=" + encodeURIComponent(props.twitterUser)).replace(/@u/g, encodeURIComponent(props.url)).replace(/@t/g, encodeURIComponent(props.title)).replace(/@d/g, encodeURIComponent(props.description)).replace(/@q/g, encodeURIComponent(props.quote)).replace(/@h/g, encodedHashtags.value).replace(/@m/g, encodeURIComponent(props.media));
    });
    if (!(key.value in networks.value)) {
      throw new Error(`Network ${key.value} does not exist!`);
    }
    const node = {
      class: `share-network-${key.value}`,
      onClick: (e) => {
        rawLink.value.substring(0, 4) === "http" ? share(shareLink.value, key.value) : touch(shareLink.value);
        e.preventDefault();
      },
      ...attrs
    };
    if (props.tag === "a") {
      node.href = "#";
    }
    return () => h(props.tag, node, slots);
  }
};
const TabContext = Symbol("TabContext");
const PanelContext = Symbol("PanelContext");
const injectContext = (key, defaultValue = null, component) => {
  const context = inject(key, defaultValue);
  if (!context) {
    const err = new Error(`<${component} /> is missing a parent provider`);
    throw err;
  }
  return context;
};
const render = ({
  props = {},
  attrs = {},
  slot = null,
  slots = null
} = {}) => h(
  "div",
  { ...attrs, ...props },
  slots && slots.default(slot)
);
const Tabs = {
  name: "Tabs",
  props: {
    modelValue: {
      type: [String, Number]
    }
  },
  emits: ["update:modelValue"],
  setup(props, { slots, emit, attrs }) {
    const active = computed(() => props.modelValue);
    const tabs = ref([]);
    function selectTab(tab) {
      emit("update:modelValue", tab);
    }
    provide(TabContext, {
      active,
      tabs,
      selectTab
    });
    return () => render({ slots, attrs });
  }
};
const Tab = {
  props: {
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    to: {
      type: [String, Object],
      required: false
    },
    disabled: {
      type: Boolean
    }
  },
  setup(props, { slots, attrs }) {
    const instance = getCurrentInstance();
    const { tabs, selectTab, active } = injectContext(TabContext, null, "Tab");
    const index2 = computed(() => tabs.value.findIndex(
      (target) => target.uid === instance.uid
    ));
    const isActive = computed(() => props.id ? props.id === active.value : index2.value === active.value);
    const activeteTab = () => {
      if (props.disabled) {
        return;
      }
      selectTab(props.id || index2.value);
    };
    watchEffect(() => {
      if (props.id || index2.value === -1) {
        tabs.value.push(instance);
      }
    });
    return () => props.to ? h(RouterLink, props, slots) : render({
      slots,
      attrs,
      props: {
        onClick: activeteTab
      },
      slot: {
        activeteTab,
        active: unref(isActive)
      }
    });
  }
};
const TabPanels = {
  name: "TabPanels",
  props: {
    modelValue: [String, Number]
  },
  setup(props, { slots, attrs }) {
    provide(PanelContext, {
      active: computed(() => props.modelValue),
      panels: ref([])
    });
    return () => render({ slots, attrs });
  }
};
const TabPanel = {
  name: "TabPanel",
  props: {
    id: {
      type: String,
      required: false
    }
  },
  setup(props, { slots, attrs }) {
    const instance = getCurrentInstance();
    const { panels, active } = injectContext(PanelContext, null, "Panel");
    const index2 = computed(
      () => panels.value.findIndex((target) => target.uid === instance.uid)
    );
    const isActive = computed(() => props.id ? props.id === active.value : active.value === index2.value);
    watchEffect(() => {
      if (index2.value === -1) {
        panels.value.push(instance);
      }
    });
    return () => isActive.value && render({ slots, attrs, props });
  }
};
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alert,
  Avatar,
  Breadcrumbs: _sfc_main$m,
  Bubble: _sfc_main$5,
  Copy: _sfc_main,
  Expander: _sfc_main$8,
  Fireworks: _sfc_main$4,
  FlexTable: _sfc_main$6,
  Icon,
  Image: _sfc_main$l,
  Loading,
  Markdown: _sfc_main$1,
  Modal,
  Notifier,
  Notify: _sfc_main$j,
  Pagination,
  Panel,
  Picture: _sfc_main$3,
  Scalator,
  ShareNetwork,
  Sharer,
  StarRating: _sfc_main$2,
  Switch: _sfc_main$9,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  TimeRemaining: _sfc_main$d,
  Toast: NToast,
  Toaster
}, Symbol.toStringTag, { value: "Module" }));
const defaultOptions = { prefix: "N" };
const index = {
  install: (app, { prefix } = defaultOptions) => {
    Object.keys(components).forEach((name) => {
      app.component(`${prefix}${name}`, components[name]);
    });
  },
  version: "2.0.0-beta.84"
};
export {
  Alert,
  Avatar,
  _sfc_main$m as Breadcrumbs,
  _sfc_main$5 as Bubble,
  _sfc_main as Copy,
  _sfc_main$8 as Expander,
  _sfc_main$4 as Fireworks,
  _sfc_main$6 as FlexTable,
  Icon,
  _sfc_main$l as Image,
  Loading,
  _sfc_main$1 as Markdown,
  Modal,
  Notifier,
  _sfc_main$j as Notify,
  Pagination,
  Panel,
  _sfc_main$3 as Picture,
  Scalator,
  ShareNetwork,
  Sharer,
  _sfc_main$2 as StarRating,
  _sfc_main$9 as Switch,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  _sfc_main$d as TimeRemaining,
  NToast as Toast,
  Toaster,
  index as default
};
//# sourceMappingURL=ui-core.js.map
